import { useSite } from '@on3/ui-lib/src/contexts/SiteProvider';
import { SiteKeys } from '@on3/ui-lib/utils/constants';
import { ExcoPlayer } from '@public/components/Ads/ExcoPlayer/ExcoPlayer';
import { StnPlayer } from '@public/components/Ads/StnPlayer';

enum VideoPlayerType {
  Exco = 'ExcoPlayer',
  Connatix = 'ConnatixPlayer',
  Stn = 'StnPlayer',
}

const stnSites = [SiteKeys.FiveGOATs];

export const VideoPlayer = () => {
  const { currentSite } = useSite();

  let selectedPlayer: VideoPlayerType = VideoPlayerType.Exco;

  if (stnSites.includes(currentSite.key)) {
    selectedPlayer = VideoPlayerType.Stn;
  }

  return (
    <>
      {selectedPlayer === VideoPlayerType.Exco && <ExcoPlayer />}
      {selectedPlayer === VideoPlayerType.Stn && <StnPlayer />}
    </>
  );
};
